// Version v4 variant fix
document.addEventListener('DOMContentLoaded', function () {
  console.log('Custom Rebuy Script loaded and DOMContentLoaded event fired.');

  function applyDiscounts() {
    const isGlobalDiscountEnabled = window.globalCustomDiscountSetting || false;
    const isCollectionSpecificEnabled = window.collectionSpecificDiscountSetting || false;

    // Exit if neither discount setting is enabled
    if (!isGlobalDiscountEnabled && !isCollectionSpecificEnabled) {
      console.log('No discount settings enabled. Exiting applyDiscounts.');
      return;
    }

    console.log(
      'Applying discounts. Collection Specific:',
      isCollectionSpecificEnabled,
      'Global:',
      isGlobalDiscountEnabled
    );

    const products = document.querySelectorAll('.rebuy-product-block');

    products.forEach((product) => {
      console.log('Processing product:', product);

      let discountHtml = '';

      // Get the price elements
      let priceElement = product.querySelector('.rebuy-money.sale span[tabindex="0"]');
      let compareAtPriceElement = product.querySelector('.rebuy-money.compare-at span');

      if (!priceElement) {
        // If sale price not found, get the regular price
        priceElement = product.querySelector('.rebuy-money span[tabindex="0"]');
      }

      if (!priceElement) {
        console.warn('Price element not found for product:', product);
        return;
      }

      // Get the price text
      const priceText = priceElement.textContent.trim();

      // Remove any existing custom discount display
      const existingDiscountElement = product.querySelector('.custom-discount');
      if (existingDiscountElement) {
        existingDiscountElement.remove();
      }

      // Reset the display of price elements to ensure they are visible by default
      priceElement.style.display = '';
      if (compareAtPriceElement) {
        compareAtPriceElement.style.display = '';
      }

      if (isCollectionSpecificEnabled) {
        // Apply collection-specific discounts using tags
        const productTags = [...product.classList]
          .filter((cls) => cls.startsWith('tag-'))
          .map((cls) => cls.replace('tag-', ''));

        console.log('Product Tags:', productTags);

        if (productTags.includes('upto35off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">UP TO 35% OFF</div>
            </div>
          `;
        } else if (productTags.includes('50off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">50% OFF</div>
            </div>
          `;
          
        } else if (productTags.includes('bogo')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">Buy 1 Get 1 FREE!</div>
            </div>
          `;
          
        } else if (productTags.includes('40off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">40% OFF</div>
            </div>
          `;
        } else if (productTags.includes('20off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">+ Extra 20% Off In Cart</div>
            </div>
          `;
        } else if (productTags.includes('25off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">25% OFF</div>
            </div>
          `;
        } else if (productTags.includes('upto70off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">UP TO 70% OFF</div>
            </div>
          `;
        } else if (productTags.includes('75off')) {
          // Hide the default price elements
          priceElement.style.display = 'none';
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }

          discountHtml = `
            <div class="custom-discount">
              <span style="color: red; font-size: .9rem; font-weight: bold;">${priceText}</span>
              <div style="color: red; font-size: .9rem; font-weight: bold;">75% OFF</div>
            </div>
          `;
        } else {
          console.log('No matching tag for collection-specific discount. Skipping product:', product);
          return; // Skip this product if no matching tag
        }
      } else if (isGlobalDiscountEnabled) {
        // Apply global discounts
        console.log('Applying global discounts.');

        // Remove currency symbols and commas
        const originalPriceNumber = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        if (isNaN(originalPriceNumber)) {
          console.warn('Invalid original price for global discount:', priceText);
          return;
        }

        const discount25 = originalPriceNumber * 0.25;
        const discountedPrice25 = originalPriceNumber - discount25;
        const discount10 = originalPriceNumber * 0.10;
        const discountedPrice10 = originalPriceNumber - discount10;
        // Hide the default price elements
        priceElement.style.display = 'none';
        if (compareAtPriceElement) {
          compareAtPriceElement.style.display = 'none';
        }
        /*
        discountHtml = `
          <div class="custom-discount">
            <span style="color: red; font-size: .9rem; font-weight: bold;">$${discountedPrice25.toFixed(2)}</span>
            <span style="color: black; font-size: .9rem; text-decoration: line-through; font-weight: bold; margin-left: 8px;">$${originalPriceNumber.toFixed(2)}</span>
            <p style="line-height: 1.5em;">
              <span style="color: red; font-size: .7rem; font-weight: bold;">25% OFF SITEWIDE</span>
            </p>
          </div>
        `;
        */
        discountHtml = `
          <div class="custom-discount">
            <span style="color: red; font-size: .9rem; font-weight: bold;">$${discountedPrice10.toFixed(2)}</span>
            <span style="color: black; font-size: .9rem; text-decoration: line-through; font-weight: bold; margin-left: 8px;">$${originalPriceNumber.toFixed(2)}</span>
            <p style="line-height: 1.5em;">
              <span style="color: red; font-size: .7rem; font-weight: bold;">WITH $50+ PURCHASE</span>
            </p>
          </div>
        `;
        
      } else {
        // No discounts to apply; price elements remain visible
        return;
      }

      // Insert the discount HTML if applicable
      if (discountHtml) {
        const priceContainer = product.querySelector('.rebuy-product-price div');
        if (priceContainer) {
          priceContainer.insertAdjacentHTML('beforeend', discountHtml);
          console.log('Custom discount applied for product:', product);
        } else {
          console.warn('Price container not found for product:', product);
        }
      }
    });
  }

  function handleDOMChanges(mutationsList) {
    let shouldReapplyDiscounts = false;

    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldReapplyDiscounts = true;
        break;
      }
    }

    if (shouldReapplyDiscounts) {
      console.log('Reapplying discounts due to DOM changes.');
      setTimeout(() => {
        observer.disconnect();
        applyDiscounts();
        observer.observe(targetNode, config);
      }, 500);
    }
  }

  const observer = new MutationObserver(handleDOMChanges);
  const config = { childList: true, subtree: true };

  applyDiscounts();

  const targetNode = document.body;
  observer.observe(targetNode, config);
});